import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Card } from 'ui-components/components/card';
import { FlexRow, FlexColumn, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { getInventorySettingsPath } from '../../../../../../../routes/constants';
import { TodoCard } from '../../../../todo-cards/todo-card';
import { todoCardIds } from '../../../../todo-cards/todo-card-ids';
import inventoryDoLaterCardIllustration from '../../../../svgs/inventory-do-later-card-illustration.svg';
import { messages } from './messages';
import style from './style.module.less';

const HELP_CENTER_ARTICLE_LINK = 'https://help.shipstation.com/hc/en-us/articles/360025870392-Inventory-in-ShipStation';
const INVENTORY_MANAGEMENT_PATH = getInventorySettingsPath();

export const WithoutInventoryStep = () => {
  const intl = useIntl();

  return (
    <Card className={style.card}>
      <FlexRow className={style['columns-wrapper']}>
        <FlexColumn className={style['content-column']} gap={Gap.Space16}>
          <FlexRow gap={Gap.Space16}>
            <Text textType={TextType.H3} value={messages.cardTitle} />
            <div>
              <Text className={style['content-column-description']} textType={TextType.Paragraph} value={messages.cardDescription} />
              <Button
                className={style['description-link']}
                href={HELP_CENTER_ARTICLE_LINK}
                rel='noopener noreferrer'
                target='_blank'
                theme={THEME_CONSTANTS.link}
              >
                <FormattedMessage {...messages.linkText} />
              </Button>
            </div>
            <Button href={INVENTORY_MANAGEMENT_PATH} target='_blank' theme={THEME_CONSTANTS.primary}>
              <FormattedMessage {...messages.buttonText} />
            </Button>
          </FlexRow>
          <TodoCard id={todoCardIds.SHIPSTATION_INVENTORY} onlyFooter />
        </FlexColumn>
        <FlexColumn className={style.illustration}>
          <img alt={intl.formatMessage(messages.shipstationInventoryIllustrationAlt)} src={inventoryDoLaterCardIllustration} />
        </FlexColumn>
      </FlexRow>
    </Card>
  );
};
